import { Helmet } from "react-helmet-async";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { FeaturedProperties } from "@/components/FeaturedProperties";
import ServicesSection from "@/components/ServicesSection";
import { DestinationsSection } from "@/components/DestinationsSection";
import GlobalNetworkSection from "@/components/GlobalNetworkSection";
import { HeritageSection } from "@/components/HeritageSection";
import NewsletterSubscription from "@/components/NewsletterSubscription";
import TestimonialsSection from "@/components/TestimonialsSection";
import FAQSection from "@/components/FAQSection";
import { AboutSection } from "@/components/AboutSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import ExclusiveAccessCTA from "@/components/ExclusiveAccessCTA";
import VIPConsultationBanner from "@/components/VIPConsultationBanner";
import ResidencyVisaSection from "@/components/ResidencyVisaSection";

const Index = () => {
  return (
    <>
      <Helmet>
        <title>Agota Estate | Luxury Real Estate Investment Across 15 Global Markets</title>
        <meta name="description" content="Discover exceptional luxury properties across Monaco, Dubai, London, Italy, Spain, Abu Dhabi, Hong Kong, USA, France, Australia & more. Curated estates for discerning investors. €2M-€50M+." />
        <meta name="keywords" content="luxury real estate, Monaco property, Dubai penthouse, London mansion, Hong Kong estate, Italian villa, Spanish estate, Abu Dhabi villa, investment property, UHNWI real estate, generational wealth" />
        <link rel="canonical" href="https://agotaestate.com" />
        <meta property="og:title" content="Agota Estate | Noble Legacy. Global Destiny." />
        <meta property="og:description" content="Curating exceptional estates across 15 premier global markets for families who measure wealth in generations." />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "RealEstateAgent",
            "name": "Agota Estate",
            "description": "Luxury real estate investment advisory for ultra-high-net-worth individuals across 15 global markets",
            "url": "https://agotaestate.com",
            "telephone": "+37060044499",
            "email": "ask@agotaestate.com",
            "areaServed": ["Monaco", "Dubai", "London", "Italy", "Spain", "Abu Dhabi", "KSA", "Hong Kong", "Macau", "USA", "France", "Australia", "Qatar", "Switzerland", "Israel"],
            "priceRange": "€2,000,000 - €50,000,000+",
            "hasOfferCatalog": {
              "@type": "OfferCatalog",
              "name": "Luxury Properties",
              "itemListElement": [
                { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Monaco Penthouses" }},
                { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Dubai Waterfront Properties" }},
                { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "London Mansions" }},
                { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Italian Villas" }},
                { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "Hong Kong Estates" }},
                { "@type": "Offer", "itemOffered": { "@type": "Product", "name": "French Riviera Villas" }}
              ]
            }
          })}
        </script>
      </Helmet>
      <main className="min-h-screen bg-background text-foreground">
        <Navbar />
        <HeroSection />
        <FeaturedProperties />
        
        {/* VIP Quick Contact Banner - High conversion point */}
        <VIPConsultationBanner />
        
        <ServicesSection />
        <DestinationsSection />
        
        {/* Investment Assessment CTA - Primary lead capture funnel */}
        <ExclusiveAccessCTA />
        
        <GlobalNetworkSection />
        <ResidencyVisaSection />
        <HeritageSection />
        
        {/* Newsletter Section */}
        <section className="py-20 bg-muted/30">
          <div className="container mx-auto px-6 lg:px-12 max-w-4xl">
            <NewsletterSubscription source="homepage" variant="hero" />
          </div>
        </section>
        
        <TestimonialsSection />
        <FAQSection />
        <AboutSection />
        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default Index;
